import { handleGetRequest, handlePostRequest } from "./httpClient";

export const updateTerms = async (input) => {
  return await handlePostRequest(`/terms`, input);
};

export const getTerms = async () => {
  return await handleGetRequest(`/terms`);
};
